import type { VoidFunctionComponent } from 'react';

import { useUpdateUserTeamGroupRoles } from '../../../../../../../hooks/api';
import TeamRoleSelector from '../../../TeamRoleSelector';

type Props = {
  userId: number;
  teamGroupId: number;
  roleId?: number;
  isDisabled?: boolean;
};

/**
 * On each row of the TeamGroupMembersTable, this dropdown allows the current user
 * to change the role of the member quickly.
 *
 * @param {Props} props - The component props.
 * @param {number} props.userId - The ID of the user to change the role for.
 * @param {number} props.teamGroupId - The ID of the team group to change the role for.
 * @param {number} props.roleId - The ID of the role to select.
 */
const TeamGroupMembersTableRoleDropdown: VoidFunctionComponent<Props> = (
  { userId, teamGroupId, roleId, isDisabled },
) => {
  const { mutate: updateUserTeamRoles } = useUpdateUserTeamGroupRoles(teamGroupId);

  return (
    <TeamRoleSelector
      userId={userId}
      roleId={roleId}
      teamId={teamGroupId}
      isDisabled={isDisabled}
      handleChangeRole={(_userId, updatedRoleId: number) => {
        //  If the role ID is the same as the current role ID, do nothing.
        if (roleId === updatedRoleId) {
          return;
        }
        //  Otherwise, update the role. No need to await this.
        updateUserTeamRoles({
          userId,
          newRoles: [{
            teamId: teamGroupId,
            roleId: updatedRoleId,
          }],
        });
      }}
    />
  );
};

export default TeamGroupMembersTableRoleDropdown;
